/**
 * 통합 폴리라인 컴포넌트
 * 카카오맵 또는 Leaflet 폴리라인을 자동으로 선택
 */

import { Polyline as KakaoPolyline } from "react-kakao-maps-sdk";
import { LeafletPolyline } from "./LeafletMapWrapper";
import { useCurrentMapProvider } from "./MapProviderContext";

export interface UnifiedPolylineProps {
  path: { lat: number; lng: number }[];
  strokeWeight?: number;
  strokeColor?: string;
  strokeOpacity?: number;
  strokeStyle?: "solid" | "shortdash" | "shortdot" | "shortdashdot" | "shortdashdotdot" | "dot" | "dash" | "longdash" | "dashdot" | "longdashdot" | "longdashdotdot";
}

/**
 * 통합 폴리라인 컴포넌트
 */
export const UnifiedPolyline: React.FC<UnifiedPolylineProps> = ({
  path,
  strokeWeight = 5,
  strokeColor = "#3388ff",
  strokeOpacity = 0.7,
  strokeStyle = "solid",
}) => {
  // Context에서 현재 활성화된 맵 제공자 가져오기
  const mapProvider = useCurrentMapProvider();

  if (mapProvider === "osm") {
    // Leaflet 폴리라인
    return (
      <LeafletPolyline
        path={path}
        strokeWeight={strokeWeight}
        strokeColor={strokeColor}
        strokeOpacity={strokeOpacity}
      />
    );
  }

  // 카카오맵 폴리라인
  return (
    <KakaoPolyline
      path={path}
      strokeWeight={strokeWeight}
      strokeColor={strokeColor}
      strokeOpacity={strokeOpacity}
      strokeStyle={strokeStyle}
    />
  );
};

